import React, { useContext, useState } from "react";
import format from "lib/format";
import config from "lib/config";
import PropTypes from "prop-types";
import styled from "styled-components";
import LangContext from "../../../langContext";
import * as CONSTANTS from "domains/programs/constants";
import { navigateToMsTeams } from "../../../functions";
import { Button } from "Components/Base/Inputs/Button";
import dompurify from "dompurify";

const DESCRIPTION_LIMIT = 200;

const StyledProgramHeader = styled.div`
  margin: 0 0 10px 0;

  img {
    width: 100%;
    max-width: 450px;
    aspect-ratio: 16/9;
    object-fit: contain;
  }

  .header-info {
    padding: 10px;
  }
`;

const Header = (props) => {
  const sanitizer = dompurify.sanitize;
  const languageContext = useContext(LangContext);
  const [showMore, setShowMore] = useState(false);
  const { isPreview } = props;
  const {
    programId,
    title,
    activityTitle,
    description,
    longDescriptionForParticipants,
    descriptionFromProgramSession,
    responsible,
    registrationDate,
    image,
    microsoftTeamId,
    activityId,
  } = props.data;

  const descriptionToShow = descriptionFromProgramSession
    ? descriptionFromProgramSession
    : longDescriptionForParticipants;

  const displayShowMoreToggle =
    descriptionToShow && descriptionToShow.length > DESCRIPTION_LIMIT;

  const formatedDescriptionText =
    displayShowMoreToggle && !showMore
      ? descriptionToShow.substr(0, DESCRIPTION_LIMIT) + "..."
      : descriptionToShow;

  const dateFormat =
    config && config.shortDateFormat
      ? config.shortDateFormat.toUpperCase()
      : "yyyy-MM-dd HH:mm";

  const imageUrl = image
    ? format.url(
        `/utils/streamfile.aspx?type=courseobjectimage&param=${programId}/${encodeURIComponent(
          image,
        )}`,
      )
    : format.url(CONSTANTS.PROGRAM_IMAGE);

  return (
    <StyledProgramHeader>
      <div className="flex flex-space-b">
        <div className="header-info column">
          <h1>{title}</h1>
          <h2>{activityTitle}</h2>
          {responsible && (
            <div>
              <strong>{languageContext("responsible1")}: </strong>
              <span>{responsible}</span>
            </div>
          )}
          <div>
            <strong>{languageContext("enrolled")}: </strong>
            {!isPreview && (
              <span>{moment(registrationDate).format(dateFormat)}</span>
            )}
          </div>
          {microsoftTeamId != "" && (
            <div className="flex">
              <Button
                onClick={() => navigateToMsTeams(activityId)}
                label={languageContext("toMSTeams")}
              />
            </div>
          )}
          {!displayShowMoreToggle && (
            <div
              className="flex-1"
              dangerouslySetInnerHTML={{
                __html: sanitizer(descriptionToShow),
              }}
            />
          )}
          {displayShowMoreToggle && (
            <>
              <div
                className="flex-1"
                dangerouslySetInnerHTML={{
                  __html: sanitizer(formatedDescriptionText),
                }}
              />
              <br />
              <span
                className="pointer underline"
                onClick={() => setShowMore(!showMore)}
                tabIndex="0"
              >
                {showMore
                  ? languageContext("showlessinfo")
                  : languageContext("readmore")}
              </span>
            </>
          )}
        </div>
        <div>{<img src={imageUrl} alt={title} />}</div>
      </div>
    </StyledProgramHeader>
  );
};

Header.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    activityTitle: PropTypes.string,
    responsible: PropTypes.string,
    registerdate: PropTypes.string,
    image: PropTypes.string,
  }),
};

Header.defaultProps = {
  activityTitle: "",
  responsible: "",
  registerdate: "",
  image: null,
};

export default Header;
